<template>
  <div class="single-product-add">
    <div class="prices">
      <div class="price t-price">
        {{ $formatMoney(price) }}
      </div>
      <div class="compare-price t-price" v-if="compareAtPrice">
        {{ $formatMoney(compareAtPrice) }}
      </div>
    </div>

    <div class="variants">
      <puori-select
        class="flavour-select"
        v-if="flavours && flavours.length > 1"
        v-model="currentFlavour"
      >
        <option
          v-for="flavour in flavours"
          :key="flavour.handle"
          :value="flavour.handle"
          >{{ flavour.name }}</option
        >
      </puori-select>
      <puori-select
        class="size-select"
        v-model.number="selectedVariant"
        v-if="product.variants.length > 1"
      >
        <option
          v-for="variant in product.variants"
          :key="variant.id"
          :value="variant.id"
          >{{ variant.title }}</option
        >
      </puori-select>
    </div>
    <div class="subscription" v-if="subscriptionSettings">
      <subscription-checkbox
        v-model="subscription"
        :disabled="!product.available"
        :title="subscriptionTitle"
        :body="subscriptionDetails"
      />
    </div>

    <div class="add">
      <quantity v-model="quantity" />
      <button
        class="button add-button"
        :class="{ 'button--grayed': !product.available }"
        :disabled="!product.available"
        @click="handleAddClick"
      >
        <span v-if="product.available">
          {{ $translations.products.product.add_to_cart }} </span
        ><span v-else>
          {{ $translations.products.product.out_of_stock }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import store from "../store";
import Quantity from "./quantity.vue";
import SubscriptionCheckbox from "./subscription-checkbox.vue";
import PuoriSelect from "./puori-select.vue";

export default {
  selector: "#vue-single-product-add",
  components: { SubscriptionCheckbox, Quantity, PuoriSelect },
  store,
  props: {
    product: {
      type: Object,
      required: true
    },
    subscriptionSettings: [Object, Boolean],
    initialVariantId: {
      type: Number,
      required: true
    },
    flavours: {
      type: Array,
      required: false,
      default: () => []
    },
    subscriptionDetails: {
      type: String,
      required: true
    },
    subscriptionTitle: {
      type: String,
      required: true
    }
  },
  data() {
    const currentFlavour = this.flavours.find(flavour => flavour.current);
    return {
      quantity: 1,
      subscription:
        this.subscriptionSettings &&
        this.subscriptionSettings.subscriptionFirst,
      selectedVariant: this.initialVariantId,
      currentFlavour: currentFlavour && currentFlavour.handle
    };
  },
  computed: {
    variant() {
      return this.product.variants.find(
        variant => variant.id === this.selectedVariant
      );
    },
    price() {
      if (!this.variant) return 0;
      return this.variant.price;
    },
    compareAtPrice() {
      if (!this.variant) return 0;
      return this.variant.compare_at_price;
    }
  },
  watch: {
    currentFlavour() {
      const flavour = this.flavours.find(
        flavour => flavour.handle === this.currentFlavour
      );
      if (!flavour || flavour.current) return;
      window.location = flavour.url;
    },
    selectedVariant() {
      const variant = this.product.variants.find(
        variant => variant.id === this.selectedVariant
      );
      console.log(variant);
      if (!variant) return;
      const imageId = variant.featured_image.id;
      this.$eventBus.$emit("variant_image_id", imageId);
    }
  },
  methods: {
    ...mapActions({
      addToCart: "cart/add"
    }),
    handleAddClick() {
      if (this.subscription) {
        this.handleAddSubscription();
      } else {
        this.addToCart({
          id: this.selectedVariant,
          quantity: this.quantity
        });
      }
    },

    handleAddSubscription() {
      const variant = this.subscriptionSettings.product.variants.find(
        ({ id }) => id === this.selectedVariant
      );
      if (!variant) {
        console.log("errro variant", this.selectedVariant);
      }
      const duplicateId = variant.duplicateId;
      const data = {
        quantity: this.quantity,
        id: duplicateId,
        "properties[shipping_interval_frequency]": this.subscriptionSettings.interval.frequencies[0].toString(),
        "properties[shipping_interval_unit_type]": this.subscriptionSettings.interval.unit,
        "properties[subscription_id]": this.subscriptionSettings.subscriptionId
      };

      this.addToCart(data);
    }
  }
};
</script>

<style lang="scss" scoped>
.price,
.compare-price {
  font-size: 16px;

  @include media("<=tablet") {
    text-align: center;
  }
}

.compare-price {
  opacity: 0.333;
  text-decoration: line-through;
}

.variants {
  margin-top: 32px;
  display: flex;
  * {
    flex: 1;
    + * {
      margin-left: 8px;
    }
  }
}

.subscription {
  margin-top: 32px;
}

.add {
  margin-top: 32px;
  display: flex;

  * + * {
    margin-left: 16px;
  }
}

.add-button {
  @include media("<=tablet") {
    flex: 1;
  }
}
</style>
